// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Morn',
      'Arial',
      'sans-serif',
    ].join(','),
    // Optionally set specific weights for headings
    h1: { fontWeight: 700 },
    h2: { fontWeight: 500 },
    // etc.
  },
  // You can override additional MUI settings here
});

export default theme;